var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#545454;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.12,218.13h-37.93v-59.4c0-14.16-.25-32.4-19.73-32.4s-22.78,15.43-22.78,31.37v60.43h-37.93v-122.16h36.41v16.69h.51c7.42-12.7,21.23-20.28,35.93-19.73,38.45,0,45.53,25.29,45.53,58.19l-.02,67.01h0ZM56.96,79.27c-12.16,0-22.01-9.85-22.02-22.01,0-12.16,9.85-22.01,22.01-22.02,12.16,0,22.01,9.85,22.02,22.01,0,12.16-9.85,22.01-22.01,22.02M75.92,218.13h-37.97v-122.16h37.97v122.16h0ZM237.03.02H18.89C8.58-.1.13,8.16,0,18.47v219.05c.12,10.31,8.58,18.58,18.89,18.47h218.14c10.34.13,18.82-8.14,18.97-18.47V18.45C255.85,8.12,247.36-.13,237.03,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.37d93b181255b5b91ab3d3ee827993fa.svg";
export { ForwardRef as ReactComponent };